import { Medal } from "lucide-react";
import { ShareImageDialog } from "@/components/BadgeShare";
import { renderBadgeImage } from "@/lib/badgeImage";

const GOLD = { label: "GOLDENES HELDEN-ABZEICHEN", ring: ["#FDE68A", "#F59E0B"], iconColor: "#D97706" };

export function QuestHeroShare({ hero, user, onClose }) {
  const link = `${window.location.origin}/registrieren?ref=${user.referral_code}`;
  const badge = { title: "Aufgaben-Held", description: `Platz ${hero.rank} bei „${hero.title}“ · ${hero.total} Beiträge` };
  return (
    <ShareImageDialog prefix="quest-hero" title="Helden-Abzeichen teilen" alt="Aufgaben-Held" fileBase={`itzcouple-aufgaben-held-${hero.quest_id}`} onClose={onClose}
      description="Zeig dein goldenes Abzeichen in deiner Instagram- oder TikTok-Story. Dein Einladungslink ist mit drauf."
      msg={`Ich bin Aufgaben-Held in der itzPlay Community – Platz ${hero.rank} bei „${hero.title}“! 🏅 Mach mit: ${link}`}
      render={(format) => renderBadgeImage({ badge, Icon: Medal, user, link, format, ...GOLD })} deps={[hero.quest_id, user.user_id, link]} />
  );
}
